import { Select, MenuItem } from "@mui/material";
import { GridFilterInputValueProps } from "@mui/x-data-grid";
import { SelectChangeEvent } from "@mui/material/Select";
import { usePositions } from "../../../../hooks/usePositions";


export function FilterPositionInput(props: GridFilterInputValueProps) {
  const { item, applyValue } = props;
  const {
    positions,
  } = usePositions();
  const handleChange = (event: SelectChangeEvent) => {
    applyValue({ ...item, value: event.target.value });
  };

  return (
    <Select
      value={item.value || ""}
      onChange={handleChange}
      displayEmpty
      fullWidth
    >
      <MenuItem value="">All</MenuItem>
      {positions.map((position: any) => (
        <MenuItem key={position.name} value={position.name}>
          {position.name}
        </MenuItem>
      ))}
    </Select>
  );
}